import React from "react";
import { Link } from "react-router-dom";
import { imageBasePath } from "../../Utils/config";

const HomeCards = ({ image, name, background, to }) => {
  return (
    <Link to={to}>
      <div
        className={`w-[280px] h-[232px] cursor-pointer ${background} flex flex-col justify-end items-center shadow-[0px_0px_15px_#00000040]`}
      >
        <div>
          <img src={imageBasePath + image} alt={name} />
        </div>
        <p
          className={`font-font-Titillium font-normal group-hover:font-bold text-[20px] leading-[30px] text-center tracking-[0.0063em] text-[#141414] uppercase mt-6 mb-4`}
        >
          {name}
        </p>
      </div>
    </Link>
  );
};

export default HomeCards;
